import React from 'react';
import ReactDOM from 'react-dom';

//  <script type="text/javascript" src="/common/lib/osWidget_locales.js"></script>

//jsx common 
import {DateChooser} from '../common/dateChooser.jsx';
import {ModalWidgetWaiting, ModalWithClose, ModalTitle, ModalBody, SimpleDataGrid , L, TimeAgo} from '../common/components.jsx';

export function OrderNotes_Open(legacy_no) {

  console.log("OrderNotes_Open");
  console.log(legacy_no);

  //$('td, th, h3').tooltipOnOverflow();

  //---- get data and render whole UI/widget...
  var Params = {};
  Params.lookupType  = "legacy_order_no";
  Params.lookupValue = legacy_no;

  // Fetch order data, including comments
  console.log("Fetching order...");
  console.log(Params);
  GET("/os/ossui/v1/in/widget/order", Params,
    function(respOrder) {
      console.log(respOrder);

      if (respOrder.status == 'N') {
        alert(respOrder.message);
      } else {
        console.log(respOrder.data);
        //order = respOrder.data;
      }
      // Fetch the notes data
      console.log("Fetching notes...");
              // now show everything
      var notesContainer = document.getElementById('notesbody');
      if (!notesContainer) {
          notesContainer = document.createElement('div');
          notesContainer.id = 'notesbody';
          document.body.appendChild(notesContainer);
      }
      $('#ossNotesModal').modal('hide');
      ReactDOM.render(
        <OrderNotes order={respOrder.data} width={"940px"} />
        , notesContainer
      );
      $('#ossNotesModal').modal( { backdrop: 'static'} );
    }
  );
}

function getNotesTextWithBRs(t) {
   if (!t) return t;
   var a = t.split('\\n');
   if (a.length < 2) { return t }
   var out = [ a[0] ]
   for (var i=1; i<a.length; i++) {
      out.push( React.createFactory('br'));
      out.push( a[i] );
   }
   return out;
}

// Sanitize function to neutralize HTML/script tags
function sanitizeInput(input) {
  if (typeof input === 'string') {
    return input.replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
  return input;
}


class OrderNotesButton extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    var legacy_no = this.props.legacy_no;
    console.log(legacy_no);
    return(<a href="#" onClick={this.handleNotes}>n</a>);
  }
};


//----------------------------------------------------------------------
//   NoteEntry
//
//----------------------------------------------------------------------
class NoteEntry extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { order, threadId, noteId, creator, createTime, noteText } = this.props;

    const sanitizedCreator = sanitizeInput(creator);
    const sanitizedNoteText = sanitizeInput(noteText);

    let prefix = '';
    if (window.mobileMode) {
      prefix = '/ext';
    }

    return (
      <div key={"note_id_" + noteId}>
        <table>
          <tbody>
            <tr>
              <td rowSpan="3" style={{ verticalAlign: "top", padding: "0px 3px 0px 0px" }}>
                {/* Ensure src is safe by sanitizing or validating it */}
                <img width="36" alt="Creator avatar" src={prefix + "/os/ossui/v1/in/avatar/" + sanitizedCreator} />
              </td>
              <td style={{ verticalAlign: "top" }}>
                <span style={{ fontSize: "11px", color: "#0096d6" }}>{sanitizedCreator}</span>
                &nbsp;&#8226;&nbsp;
                <span style={{ fontSize: "11px" }}><TimeAgo time={createTime} />:</span>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style={{
                    fontSize: "11px",
                    fontFamily: "Consolas, Courier New",
                    margin: "3px 0px 0px 0px",
                    padding: "4px 0px 4px 4px",
                    borderLeft: "2px solid #0096d6",
                  }}
                >
                  {/* Render sanitized text */}
                  {sanitizedNoteText}
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ padding: "0px 0px 5px 0px", lineHeight: "11px" }}>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={"/os/SalesAdminView.tcl?otdComment=1&thread=" + threadId + "&os=" + order.legacy_order_no}
                  style={{ fontSize: "11px" }}
                >
                  <i className="glyphicon glyphicon-arrow-right" />
                  &nbsp;reply
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
      </div>
    );
  }
}


export class OrderNotes extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      order: this.props.order,
      accContacts: {},
    };
    // this.handleAddQuickNote     = this.handleAddQuickNote.bind(this);
    this.handleSetCustNote      = this.handleSetCustNote.bind(this);
    this.handleSetSingleCSRNote = this.handleSetSingleCSRNote.bind(this);
    this.handleSingleCsrNoteChange = this.handleSingleCsrNoteChange.bind(this);
    this.handleCustNoteChange      = this.handleCustNoteChange.bind(this);
    this.handleSetBackOfficeNote    = this.handleSetBackOfficeNote.bind(this);
    this.handleBackOfficeNoteChange = this.handleBackOfficeNoteChange.bind(this);
    this.getAccountContacts = this.getAccountContacts.bind(this);
    this.validateInAccContacts = this.validateInAccContacts.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    //GEGA NOT BEST PRACTICE!
    this.setState(nextProps);
    this.forceUpdate();
    return true;
  }

  handleSingleCsrNoteChange(e) {
    var stateCopy = Object.assign({}, this.state);
    stateCopy.order.csr_notes = e.target.value;
    this.setState(stateCopy);
  }

  handleCustNoteChange(e) {
    var stateCopy = Object.assign({}, this.state);
    stateCopy.order.customer_notes = e.target.value;
    this.setState(stateCopy);
  }

  handleUpdateCustNote(self, custNoteText) {

      var prefix = '';
      if (window.mobileMode) {
          prefix = '/ext';
      }
      $("#updateCustomerNoteBtn").text('Updating ...');
         POST(prefix+'/os/ossui/v1/in/customerNote', {

           legacy_order_no: self.legacy_order_no,
           note_text: custNoteText

         }, function (resp) {

           var Params = {};
           Params.lookupType  = "legacy_order_no";
           Params.lookupValue = self.legacy_order_no;

           var prefix = '';
           if (window.mobileMode) {
              prefix = '/ext';
           }

           GET(prefix+"/os/ossui/v1/in/widget/order", Params,
             function(respOrder) {
               if (respOrder.status == 'N') {
                 alert(respOrder.message);
               } else {
                 console.log(respOrder.data);
                 self.state.order = respOrder.data;
               }

              $("#updateCustomerNoteBtn").text('Update');

             }
           );
      });
  }

  handleUpdateSingleCSRNote(self, csrNoteText, nextActionDate ) {

      var prefix = '';
      if (window.mobileMode) {
        prefix = '/ext';
      }

      $("#updateSingleCSRNoteBtn").text('Updating ...');
         POST(prefix+'/os/ossui/v1/in/csrNote', {

           legacy_order_no: self.legacy_order_no,
           note_text: csrNoteText,
           next_action_date: nextActionDate

         }, function (resp) {

           var Params = {};
           Params.lookupType  = "legacy_order_no";
           Params.lookupValue = self.legacy_order_no;

           var prefix = '';
           if (window.mobileMode) {
              prefix = '/ext';
           }

           GET(prefix+"/os/ossui/v1/in/widget/order", Params,
             function(respOrder) {
               if (respOrder.status == 'N') {
                 alert(respOrder.message);
               } else {
                 console.log(respOrder.data);
                 self.state.order = respOrder.data;
               }
              $("#updateSingleCSRNoteBtn").text('Update');

             }
           );
      });
  }


  handleFocusCSR(e) {

    console.log('handleFocusCSR'); 
    $("#newCsrNote").attr("placeholder", "Leave a quick note");
    $("#newCsrNote").css({
      background: "#ffffff",
      border: "1px solid #ccc" });
    $(e.target).css("height","100px");  
    $('#oldNewNote').hide();
    $('#addQuickNote').show();
  }

  handleBlurCSR(e) {

    console.log('handleBlurCSR'); 
    $(e.target).css("height","27px");  
    setTimeout( function() {
      $('#oldNewNote').show();
      $('#addQuickNote').hide();
    }, 300);
  }

  limitCSRNotesText(e){
      //console.log(e.target.value);
      
      if(e.target.value.length > 4000){
          $('#quickNoteError').show();
          e.target.value = e.target.value.substring(0, 4000);
      }else{
          $('#quickNoteError').hide();
      }
  }


  handleSetCustNote() {   

     var txt = $('#custNote').val();
     txt = txt.replace(/\n/gm,"\\n");

     var customer_notes = this.props.order.customer_notes;
     var self = this;

     if (customer_notes == "") {
         if (txt == "") {
             $("#custNote").attr("placeholder", "Empty notes not allowed");
              $("#custNote").css({
                background: "#FDC2AA",
                border: "1px #6E6E6E solid"
              });
          } else {
              this.handleUpdateCustNote(self, txt);
          }
     } else {
         this.handleUpdateCustNote(self, txt);
     }
  }

  handleFocusCustNote(e) {
    $(e.target).css("height","100px");  
    $("#custNote").attr("placeholder", "Leave an external visible note to the customer");
    $("#custNote").css({
      background: "#ffffff",
      border: "1px solid #ccc" });
    $(e.target).css("height","100px");
  }

  handleBlurCustNote(e) {
    $(e.target).css("height","");  
  }

  limitCustNoteText(e) {
      
      if (e.target.value.length >= 500){
          $('#custNoteError').show();
          e.target.value = e.target.value.substring(0, 500);
      } else {
          $('#custNoteError').hide();
      }
  }

  handleFocusSingleCsrNote(e) {
    $(e.target).css("height","100px");  
    $("#singleCsrNote").attr("placeholder", "Leave an internal visible note (to CSRs ...)");
    $("#singleCsrNote").css({
      background: "#ffffff",
      border: "1px solid #ccc" });
    $(e.target).css("height","100px");
  }

  handleBlurSingleCsrNote(e) {
    $(e.target).css("height","");  
  }

  limitSingleCsrNoteText(e) {
      
      if (e.target.value.length >= 1000){
          $('#singleCsrNoteError').show();
          e.target.value = e.target.value.substring(0, 1000);
      } else {
          $('#singleCsrNoteError').hide();
      }
  }

  handleSetSingleCSRNote() {   

     var txt = $('#singleCsrNote').val();
     txt = txt.replace(/\n/gm,"\\n");

     var nActionDt = $('#nextActionDate').val();

     console.log('#nextActionDate.val=', nActionDt);

     var csr_notes = this.props.order.csr_notes;
     var self = this;

     if (csr_notes == "") {
         if (txt == "") {
              $("#singleCsrNote").attr("placeholder", "Empty notes not allowed");
              $("#singleCsrNote").css({
                background: "#FDC2AA",
                border: "1px #6E6E6E solid"
              });
          } else {
              this.handleUpdateSingleCSRNote(self, txt, nActionDt);
          }
     } else {
         this.handleUpdateSingleCSRNote(self, txt, nActionDt);
     }
  }

  handleBackOfficeNoteChange(e) {
    var stateCopy = Object.assign({}, this.state);
    stateCopy.order.backoffice_notes = e.target.value;
    this.setState(stateCopy);
  }

  handleFocusBackOfficeNote(e) {
    $(e.target).css("height","100px");
    $("#backOfficeNote").attr("placeholder", "Leave an internal visible note (to Back Office ...)");
    $("#backOfficeNote").css({
      background: "#ffffff",
      border: "1px solid #ccc" });
    $(e.target).css("height","100px");
  }

  handleBlurBackOfficeNote(e) {
    $(e.target).css("height","");
  }

  limitBackOfficeNoteText(e) {
    if (e.target.value.length > 2000){
      $('#backOfficeNoteError').show();
      e.target.value = e.target.value.substring(0, 2000);
    } else {
      $('#backOfficeNoteError').hide();
    }
  }

  handleUpdateBackOfficeNote(self, backOfficeNoteText, backOfficeNextActionDate) {
    var prefix = '';
    if (window.mobileMode) {
      prefix = '/ext';
    }

    $("#updateBackOfficeNoteBtn").text('Updating ...');

    POST(prefix+'/os/ossui/v1/in/backOfficeNote', {
      legacy_order_no: self.legacy_order_no,
      note_text: backOfficeNoteText,
      next_action_date: backOfficeNextActionDate

    }, function (resp) {

      var Params = {};
      Params.lookupType  = "legacy_order_no";
      Params.lookupValue = self.legacy_order_no;

      var prefix = '';
      if (window.mobileMode) {
        prefix = '/ext';
      }

      GET(prefix+"/os/ossui/v1/in/widget/order", Params, function(respOrder) {
        if (respOrder.status == 'N') {
          alert(respOrder.message);
        } else {
          console.log(respOrder.data);
          self.state.order = respOrder.data;
        }

        $("#updateBackOfficeNoteBtn").text('Update');

      });
    });
  }

  handleSetBackOfficeNote() {
    var backOfficeNoteText = $('#backOfficeNote').val();
    backOfficeNoteText = backOfficeNoteText.replace(/\n/gm,"\\n");

    var backOfficeNextActionDate = $('#backOfficeNextActionDate').val();
    console.log('#backOfficeNextActionDate.val=', backOfficeNextActionDate);

    var backoffice_notes = this.props.order.backoffice_notes;
    var self = this;

    if (backoffice_notes == "") {
      if (backOfficeNoteText == "") {
        $("#backOfficeNote").attr("placeholder", "Empty notes are not allowed");
        $("#backOfficeNote").css({
          background: "#FDC2AA",
          border: "1px #6E6E6E solid"
        });
      } else {
        this.handleUpdateBackOfficeNote(self, backOfficeNoteText, backOfficeNextActionDate);
      }
    } else {
      this.handleUpdateBackOfficeNote(self, backOfficeNoteText, backOfficeNextActionDate);
    }
  }

  componentDidMount() {
    this.getAccountContacts()
  }

  componentDidUpdate(prevProps) {
    if (this.props.order.legacy_order_no !== prevProps.order.legacy_order_no) {
      this.getAccountContacts()
    }
  }

  getAccountContacts() {
    var lon = this.props.order && this.props.order.legacy_order_no ? this.props.order.legacy_order_no : ""

    GET('/os/ossui/v1/in/widgetExpert/accountContacts?lon=' + lon, {}, function (res) {
      var accContacts = {}

      if (res.status == 'S') {
        accContacts = res.data;
      }

      this.setState({ accContacts: accContacts })
    }.bind(this))
  }

  validateInAccContacts() {
    var emails      = []
    var accContacts = this.state.accContacts

    if (accContacts.acct_om_pers_email)  {
      emails.push(...accContacts.acct_om_pers_email.split(";").map(item => item.trim()));
    }

    if (accContacts.acct_om_pers_sec_email)  {
      emails.push(...accContacts.acct_om_pers_sec_email.split(";").map(item => item.trim()));
    }

    if (emails.includes(UserSettings.user_id)) return true

    return false
  }

  render() {

    console.log("In OrderNotes...");

    var width = "620px";
    if (this.props.width) {
      width = this.props.width;
    }
        
    var order    = this.state.order;
    var order_no = order.order_no;

    this.legacy_order_no = order.legacy_order_no;

    var escalationNotes = [];
    var escalationNotesHist = [];
    var escalationNotesCount = 0;
    var csrNotes = [];
    var csrNotesHist = [];
    var csrNotesCount = 0;
    var scNotes = [];
    var scNotesHist = [];
    var scNotesCount = 0;
    var headerComments = [];
    var headerCommentsHist = [];
    var headerCommentsCount = 0;

    var csrNotesThreads = [];
    var escThreads      = [];
    var scEscThreads    = [];
    
    var noteId = 1;


    // Prepare header comments
    var comments = order.comments;
    if (!comments) comments = [];
    for (var i = 0; i < comments.length; i++) {
      headerComments.push(
        [ comments[i].key == "" ? T('Comment') : comments[i].key ,
          comments[i].value
        ]
      );
    }

    // Compose the HTML/React code
    var notesHeader = [
      { name: T('Notes'     ) },  
      { name: T('Created by') },  
      { name: T('Created on') }
    ];

    var commentsHeader = [
      { name: T('Type'   ) },  
      { name: T('Comment') }
    ];

    if (window.mobileMode) {
      var reducedTopPadding = ".modal-body { padding: 4px 3px 6px 3px;}";
    } else {
      var reducedTopPadding = ".modal-body { padding: 5px 15px 15px 15px;}";
    }

    var goBack = null;
    var hideClose = null;

    if (this.props.withoutModal) {
        goBack = <button onClick={() => this.props.history.goBack()} className="bar-page-options-go-back"></button>
        hideClose = true;
    } 

    var csr_notes_textRows = 1;
    var csr_notes = order.csr_notes.replace(/\\n/g, "\n");
    csr_notes_textRows= csr_notes.split(/\n/).length;

    var singleCSRLastUpdateText  = "";     
    if (order.csr_notes_updater != undefined && order.csr_notes_updater != "") {
       singleCSRLastUpdateText = (
        <div style={{ "marginTop":"1px", "fontSize": "11px"}}>
          last updated by <b>{sanitizeInput(order.csr_notes_updater)}</b> at <b><TimeAgo time={order.csr_notes_lupd}/></b>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <span style={{"float":"right"}}>
          next action date:&nbsp;&nbsp;
          <DateChooser id="nextActionDate" dateValue={order.next_action_date} placeholder="" style={{"display":"inline", "width":"71px", "fontSize":"12px", "padding":"3px" }}/>
          </span>
        </div>
       )
    } else {
       singleCSRLastUpdateText = (
        <div style={{ "marginTop":"1px", "fontSize": "11px"}}>
          <span style={{"float":"right"}}>
            next action date:&nbsp;&nbsp; 
            <DateChooser id="nextActionDate" dateValue={order.next_action_date} placeholder="" style={{"display":"inline", "width":"71px", "fontSize":"12px", "padding":"3px" }}/>
          </span>
        </div>        
       )
    }

    var backoffice_notes_text_rows = 1;
    var backoffice_notes = order.backoffice_notes.replace(/\\n/g, "\n");
    backoffice_notes_text_rows = backoffice_notes.split(/\n/).length;

    var backOfficeNotesLastUpdateText = "";
    if (order.backoffice_notes_updater != undefined && order.backoffice_notes_updater != "") {
      backOfficeNotesLastUpdateText = (
        <div style={{ "marginTop":"1px", "fontSize": "11px"}}>
          last updated by <b>{sanitizeInput(order.backoffice_notes_updater)}</b> at <b><TimeAgo time={order.backoffice_notes_lupd}/></b>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <span style={{"float":"right"}}>
            next action date:&nbsp;&nbsp;
            <DateChooser id="backOfficeNextActionDate" dateValue={order.backoffice_notes_action_date} placeholder="" style={{"display":"inline", "width":"71px", "fontSize":"12px", "padding":"3px" }}/>
          </span>
        </div>
      )
    } else {
       backOfficeNotesLastUpdateText = (
        <div style={{ "marginTop":"1px", "fontSize": "11px"}}>
          <span style={{"float":"right"}}>
            next action date:&nbsp;&nbsp;
            <DateChooser id="backOfficeNextActionDate" dateValue={order.backoffice_notes_action_date} placeholder="" style={{"display":"inline", "width":"71px", "fontSize":"12px", "padding":"3px" }}/>
          </span>
        </div>
       )
    }

    var customer_notes_textRows = 1;
    var customer_notes = order.customer_notes.replace(/\\n/g, "\n");
    customer_notes_textRows= customer_notes.split(/\n/).length;
   
    var lastUpdateText = "";
    if (order.customer_notes_updater != undefined && order.customer_notes_updater != "") {
       lastUpdateText = (
        <div style={{ "fontSize": "11px"}}>
          last updated by <b>{sanitizeInput(order.customer_notes_updater)}</b> at <b><TimeAgo time={order.customer_notes_lupd}/></b>
        </div>
       )
    }

    var UpdateCustomerNoteButton = ""

    if ( UserSettings.memberOf("OSS_ExternalNote")
      || this.validateInAccContacts()
    ) {
      UpdateCustomerNoteButton =
         <button id="updateCustomerNoteBtn" className="btn btn-danger btn-sm" onClick={this.handleSetCustNote} >Update</button>
    }

    var btn_NoteHistory = [];
    var btn_EscNotes = [];
    var btn_EscScreen = [];

    if (!this.props.withoutModal) {
      btn_NoteHistory.push(
            <span style={{ "position": "absolute", "right": "20px", "top":"45px"}}>
              <a className="btn btn-primary btn-sm"
                 target="notesHist" 
                 href={"/os/SalesAdminView.tcl?showWorkNotes=1&os=" + order.legacy_order_no}
               >                
                 <i className="glyphicon glyphicon-new-window"/>
                 &nbsp;&nbsp;Show complete note history
             </a>
            </span> 
      );

      btn_EscNotes.push(
        <a className="btn btn-primary btn-xs"
           target="notesHist" 
           href={"/os/SalesAdminView.tcl?action=escalation&os_no=" + order.legacy_order_no}
         >                
         <i className="glyphicon glyphicon-new-window"/>&nbsp;&nbsp;escalation screen
        </a>
      );

      btn_EscScreen.push(
        <a className="btn btn-primary btn-xs"
           target="notesHist" 
           href={"/os/SalesAdminView.tcl?action=escalation&os_no=" + order.legacy_order_no}
         >                
         <i className="glyphicon glyphicon-new-window"/>&nbsp;&nbsp;escalation screen
        </a>
      );
    } 

    var wTitle = 
        <ModalTitle handleClose={handleCloseModal}>
        {goBack}
          <b><L>Order Notes</L></b>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <L>HP Order Number</L>: {order_no}
          {/*btn_NoteHistory*/}
        </ModalTitle>

    var wBody =
        <ModalBody>

          <div className="row notesSection">
            <div className="col-sm-2" style={{ "marginLeft": "-13px"}}>CSR Note</div>
            <div className="col-sm-8">

            <textarea id="singleCsrNote" className="form-control" placeholder="Leave an internal visible note (to CSRs ...)" 
              rows={csr_notes_textRows}
              style={{ "fontSize": "12px", "marginBottom": "0px"}}
              onBlur={this.handleBlurSingleCsrNote}
              onFocus={this.handleFocusSingleCsrNote}
              onKeyDown={this.limitSingleCsrNoteText}
              value={sanitizeInput(csr_notes)}
              onChange = {this.handleSingleCsrNoteChange}/>
            {singleCSRLastUpdateText}
            </div>
            <div className="col-sm-2">
              <button id="updateSingleCSRNoteBtn" className="btn btn-danger btn-sm" onClick={this.handleSetSingleCSRNote} >Update</button>
            </div>
            <div id='singleCsrNoteError' className="col-sm-12" style={{"marginLeft": "137px", "paddingTop": "5px", "paddingBottom": "5px", "color": "red","display":"none"}}>More than 1000 characters not allowed</div>
          </div>
          {/*
          <div className="row notesSection">
            <div className="col-sm-10" style={{ "marginLeft": "-13px"}}>old CSR Notes (prior to Sept 24th 2016)</div>
            <div className="col-sm-2">
            </div>
            <div id='quickNoteError' className="col-sm-12" style={{"marginLeft": "137px", "paddingTop": "5px", "paddingBottom": "5px", "color": "red","display":"none"}}>More than 4000 characters not allowed</div>
          </div>
          {csrNotesThreads}
          */}
          <div className="row notesSection">
            <div className="col-sm-2" style={{ "marginLeft": "-13px"}}>Back Office Note</div>
            <div className="col-sm-8">
              <textarea id="backOfficeNote" className="form-control" placeholder="Leave an internal visible note (to Back Office ...)"
                rows={backoffice_notes_text_rows}
                style={{ "fontSize": "12px", "marginBottom": "0px"}}
                onBlur={this.handleBlurBackOfficeNote}
                onFocus={this.handleFocusBackOfficeNote}
                onKeyDown={this.limitBackOfficeNoteText}
                value={sanitizeInput(backoffice_notes)}
                onChange = {this.handleBackOfficeNoteChange}/>
              {backOfficeNotesLastUpdateText}
            </div>
            <div className="col-sm-2">
              <button id="updateBackOfficeNoteBtn" className="btn btn-danger btn-sm" onClick={this.handleSetBackOfficeNote} >Update</button>
            </div>
            <div id='backOfficeNoteError' className="col-sm-12" style={{"marginLeft": "137px", "paddingTop": "5px", "paddingBottom": "5px", "color": "red","display":"none"}}>
              More than 2000 characters not allowed
            </div>
          </div>

          <div className="row notesSection">
            <div className="col-sm-2" style={{ "marginLeft": "-13px"}}>Customer Note</div>
            <div className="col-sm-8">
            <textarea id="custNote" className="form-control" placeholder="Leave an external visible note to the customer" 
              rows={customer_notes_textRows}
              style={{ "fontSize": "12px", "marginBottom": "0px"}}
              onBlur={this.handleBlurCustNote}
              onFocus={this.handleFocusCustNote}
              onKeyDown={this.limitCustNoteText}
              value= {sanitizeInput(customer_notes)}
              onChange= {this.handleCustNoteChange}/>
            {lastUpdateText}
            </div>
            <div id="updatebutton" className="col-sm-2">
              {UpdateCustomerNoteButton}
            </div>
            <div id='custNoteError' className="col-sm-12" style={{"marginLeft": "137px", "paddingTop": "5px", "paddingBottom": "5px", "color": "red","display":"none"}}>More than 500 characters not allowed</div>
          </div>

          <div className="row notesSection" >
            <div className="col-sm-2" style={{ "marginLeft": "-13px"}}><L>Header Comments</L></div>
          </div>
          <SimpleDataGrid header={commentsHeader} data={headerComments}/>
          
        </ModalBody>

    if (this.props.withoutModal) {
        return (
          <div id="ossNotesFlat" width={width} >
            {wTitle}
            <style>{reducedTopPadding}</style>
            {wBody} 
          </div>
        )
    }

    return (
      <ModalWithClose id="ossNotesModal" handleClose={handleCloseModal} closeButtonText={T('Close')} width={width}>
          {wTitle}
          <style>{reducedTopPadding}</style>
          {wBody} 
      </ModalWithClose>

    );
  }
};
     
var handleCloseModal = function() {
    //window.parent.postMessage('hp_close_orderstatus_widget', '*');
    $('#ossNotesModal').modal('hide');
    event.preventDefault();
}  
